// Marks a msgid for extraction without translating it, for a label kept in an
// array or object and translated where it renders with __(label). Module-scope
// labels can't call __() directly: the ssr service switches locale per render.
// Kept out of i18n/index so the many tests that mock that module still get it.
export const __noop = (msgid) => msgid;
